'use client'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Image from 'next/image'
import 'swiper/css'
import 'swiper/css/navigation'
import './styles.css'
import { Box, Button, Typography } from '@mui/material'
import { memo } from 'react'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'

const SLIDE_BOX_SX = {
  borderRadius: '30px',
  overflow: 'hidden',
  position: 'relative',
  height: 600,
}

const OVERLAY_SX = {
  position: 'absolute',
  bottom: 10,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  width: '100%',
  textAlign: 'center',
  borderRadius: '0 0 30px 30px',
  minHeight: '35%',
  display: 'flex',
  justifyContent: 'top',
  alignItems: 'center',
  flexDirection: 'column',
}

interface Card {
    image?: string | Record<string, unknown>
    title?: string
    description?: string
    button?: {
        link?: string
        text?: string
    }
}

interface SwiperV1Props {
    cards?: Card[]
}

const Index = ({ cards = [] }: SwiperV1Props) => {
    const normalizedCards = cards.map((card) => {
        const { src } = getImageData(card.image)
        return {
            ...card,
            image: src || '/img/img-160400.jpg',
        }
    })
    return (
        <Swiper
            modules={[Navigation]}
            navigation={true}
            loop={true}
            spaceBetween={10}
            className='mySwiper'
            breakpoints={{
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            }}
        >
            {normalizedCards.map((item, index) => (
                <SwiperSlide key={'cards' + index}>
                    <Box sx={SLIDE_BOX_SX}>
                        <Image
                            src={item.image || '/img/img-160400.jpg'}
                            alt={`${item?.title}-${index}`}
                            width={300}
                            height={300}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                        <Box sx={OVERLAY_SX}>
                            <Box sx={{ width: '100%', p: 2 }}>
                                <Typography
                                    id={`slide-title-${index}`}
                                    variant='h4'
                                    color='secondary'
                                    sx={{ p: 1}}
                                >
                                    {item?.title}
                                </Typography>
                                <Typography
                                    variant='body1'
                                    color='secondary'
                                    sx={{ p: 2 }}
                                >
                                    {item?.description}
                                </Typography>
                                <Button
                                    variant='contained'
                                    href={resolveHref(item?.button?.link)}
                                    aria-labelledby={item?.title ? `slide-title-${index}` : undefined}
                                    aria-label={
                                      item?.title
                                        ? `${item?.button?.text ? item.button.text + ' — ' : ''}${item.title}`
                                        : (item?.button?.text || 'Learn more about this item')
                                    }
                                >
                                    {item?.button?.text || 'Learn more'}
                                    {item?.title && (
                                      <span className='sr-only'> — {item.title}</span>
                                    )}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}


export default memo(Index)


